export default (that) => [
  {
    exportName: that.$l('INDEX.btn_export_polist') || '导出 PO List',
    templateGroup: 'shipment-polist',
    exportCheckUrl: '/factory/shipmentBatch/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_shippingdetails') || '导出 出运明细',
    templateGroup: 'shipment-shippingdetails',
    exportCheckUrl: '/factory/shipmentInfo/shipmentBatchDetails/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_packinglist') || '导出 Packing List',
    templateGroup: 'shipment-invpk',
    exportCheckUrl: '/factory/shipmentInfo/shipmentInvPk/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_bookingorder') || '导出 托书',
    templateGroup: 'shipment-bookingorder',
    exportCheckUrl: '/factory/shipmentInfo/exportBookingOrderCheck',
  },
  {
    exportName: that.$l('INDEX.btn_export_mcert') || '导出 M-CERT',
    templateGroup: 'shipment-mcert',
    exportCheckUrl: '',
  },
  {
    exportName: that.$l('INDEX.btn_export_inbounddetailsbook') || '导出 入库明细书',
    templateGroup: 'shipment-inbounddetailsbook',
    exportCheckUrl: '/factory/shipmentInfo/exportInboundDetailsBookCheck',
  },
  {
    exportName: that.$l('INDEX.btn_export_productpacking') || '导出 产装通知书',
    templateGroup: 'shipment-productpacking',
    exportCheckUrl: '/factory/shipmentInfo/waitProductionLoad/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_inventoryentrydetails') || '导出 进仓明细',
    templateGroup: 'shipment-inventoryentrydetails',
    exportCheckUrl: '/factory/shipmentInfo/waitProductionLoad/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_packlist') || '导出 打包单',
    templateGroup: 'shipment-packlist',
    exportCheckUrl: '/factory/shipmentInfo/shipmentBatchPacking/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_shipmentdetails') || '导出 出货明细',
    templateGroup: 'shipment-shipmentdetails',
    exportCheckUrl: '/factory/shipmentInfo/shipmentDetails/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_customsdeclaration') || '导出 报关单',
    templateGroup: 'shipment-customsdeclaration',
    exportCheckUrl: '/factory/shipmentPackingList/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_customsclearance') || '导出 清关单',
    templateGroup: 'shipment-customsclearance',
    exportCheckUrl: '/factory/shipmentInfo/packlist/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_manifest') || '导出 舱单',
    templateGroup: 'shipment-manifest',
    exportCheckUrl: '/factory/shipmentInfo/shipmentManifest/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_clp') || '导出 CLP',
    templateGroup: 'shipment-clp',
    exportCheckUrl: '/factory/shipmentInfo/exportClpCheck',
  },
  {
    exportName: that.$l('INDEX.btn_export_shipmentadvice') || '导出 SHIPMENT ADVICE',
    templateGroup: 'shipment-shipmentadvice',
    exportCheckUrl: '/factory/shipmentInfo/shipmentManifest/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_packingdetails') || '导出 装箱明细',
    templateGroup: 'shipment-packingdetails',
    exportCheckUrl: '/factory/shipmentInfo/packlist/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_payment') || '导出 Payment',
    templateGroup: 'shipment-payment',
    exportCheckUrl: '/factory/shipmentInfo/packlist/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_containercheck') || '导出 集装箱检查文件',
    templateGroup: 'shipment-containercheck',
    exportCheckUrl: '/factory/shipmentInfo/exportContainerCheckCheck',
  },
  {
    exportName: that.$l('INDEX.btn_export_shippingadvice') || '导出 发运通知书',
    templateGroup: 'shipment-shippingadvice',
    exportCheckUrl: '/factory/shipmentInfo/shipment/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_clrform') || '导出 CLR form',
    templateGroup: 'shipment-clrform',
    exportCheckUrl: '/factory/shipmentInfo/exportClrFormCheck',
  },
  {
    exportName: that.$l('INDEX.btn_export_siformat') || '导出 SI format',
    templateGroup: 'shipment-siformat',
    exportCheckUrl: '/factory/shipmentInfo/exportSIFormatCheck',
  },
  {
    exportName: that.$l('INDEX.btn_export_shipmentTruckingOrder') || '导出 Trucking order',
    templateGroup: 'shipment-truckingOrder',
    exportCheckUrl: '/factory/shipmentInfo/waitProductionLoad/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_shipmentPackingList_wait_productionLoad') || '导出 Packing List(待产装)',
    templateGroup: 'shipment-packingList',
    exportCheckUrl: '/factory/shipmentInfo/waitProductionLoad/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_truckPlan') || '导出 Truck Plan',
    templateGroup: 'factory-truckPlan',
    exportCheckUrl: '/factory/shipmentInfo/waitProductionLoad/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_tc') || '导出 TC 文件',
    templateGroup: 'shipment-tc',
    exportCheckUrl: '/factory/shipmentInfo/exportTCCheck',
  },
  {
    exportName: that.$l('INDEX.btn_bl_manifest') || '导出 截单资料',
    templateGroup: 'lidl-bill-manifest-group',
    exportCheckUrl: '/factory/shipmentInfo/exportManifestCheck',
  },
  {
    exportName: that.$l('INDEX.btn_ship_detail') || '导出 走货明细',
    templateGroup: 'shipment-shipDetail',
    exportCheckUrl: '/factory/shipmentInfo/packlist/checkData',
  }
]
